<template>
  <g class="layer-labels font-medium uppercase tracking-wider">
    <g
      v-for="(p, i) in points"
      :key="'layer-label-' + i"
    >
      <line
        :x1="p.x"
        :x2="p.x + xposData"
        :y1="p.y"
        :y2="p.y + yposData"
        :stroke="colorData"
        stroke-width="1"
        stroke-dasharray="1 1"
      ></line>
      <rect
        :x="
          widerData == true
            ? p.x + xposData - rectOffsetData - 10
            : p.x + xposData - rectOffsetData
        "
        :y="p.y + yposData - 13.5"
        rx="10"
        ry="10"
        :width="widerData == true ? 90 : 70"
        height="20"
        :fill="colorData"
      ></rect>
      <text
        :key="i"
        :x="p.x + xposData"
        :y="p.y + yposData"
        :text-anchor="xalignData"
        font-size="10"
        fill="#ffffff"
      >
        {{ p.props.data[dataKeys[2]] }}
      </text>
      <circle
        v-if="hidePulseDotData"
        :cx="p.x"
        :cy="p.y"
        :fill="colorData"
        :r="8"
        :stroke-width="2"
      >
        <animate
          attributeName="r"
          attributeType="CSS"
          from="8"
          to="18"
          dur="1.5s"
          begin="0s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="opacity"
          attributeType="CSS"
          from="0.55"
          to="0"
          dur="1.5s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </g>
  </g>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { usePoints } from 'vue3-charts';

export default defineComponent({
  name: 'LabelsInsights',
  props: {
    dataKeys: {
      // type: Object as () => [string, string],
      type: Object,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    xalign: {
      type: String,
      required: true,
    },
    xpos: {
      type: Number,
      required: true,
    },
    ypos: {
      type: Number,
      required: true,
    },
    wider: {
      type: Boolean,
      required: false,
      default: false,
    },
    hidePulseDot: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    const { points } = usePoints(props.dataKeys);
    const colorData = ref(props.color);
    const xalignData = ref(props.xalign);
    const widerData = ref(props.wider);
    const hidePulseDotData = ref(props.hidePulseDot);
    const yposData = ref(parseFloat(props.ypos));
    const xposData = ref(parseFloat(props.xpos));
    const rectOffsetData = computed(function () {
      if (xalignData.value == 'left') {
        return 0;
      } else {
        return 35;
      }
    });
    return {
      points,
      colorData,
      xalignData,
      yposData,
      xposData,
      rectOffsetData,
      widerData,
      hidePulseDotData,
    };
  },
});
</script>
